const a = {
  "pharma-card": "pharma-card",
  "pharma-card__toggle": "pharma-card__toggle",
  "pharma-card__header": "pharma-card__header",
  "pharma-card__visually-hidden": "pharma-card__visually-hidden",
  "pharma-card__badge": "pharma-card__badge",
  "pharma-card__names": "pharma-card__names",
  "pharma-card__name": "pharma-card__name",
  "pharma-card__generic-name": "pharma-card__generic-name",
  "pharma-card__indication-row": "pharma-card__indication-row",
  "pharma-card__indication": "pharma-card__indication",
  "pharma-card__toggle-icon": "pharma-card__toggle-icon",
  "pharma-card__toggle-icon--open": "pharma-card__toggle-icon--open",
  "pharma-card__panel": "pharma-card__panel",
  "pharma-card__panel--open": "pharma-card__panel--open",
  "pharma-card__panel-content": "pharma-card__panel-content",
  "pharma-card--reduced-opacity": "pharma-card--reduced-opacity",
  "pharma-card--oncology-hematology": "pharma-card--oncology-hematology",
  "pharma-card--ophthalmology": "pharma-card--ophthalmology",
  "pharma-card--neuroscience": "pharma-card--neuroscience",
  "pharma-card--cardiovascular": "pharma-card--cardiovascular",
  "pharma-card--immunology": "pharma-card--immunology",
  "pharma-card--infectious-diseases": "pharma-card--infectious-diseases",
  "pharma-card--other": "pharma-card--other"
};
export {
  a as default
};
